var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal",
      attrs: { tabindex: "-1", role: "dialog", id: "newpassword" },
    },
    [
      _c("div", { staticClass: "modal-dialog", attrs: { role: "document" } }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "modal-body" }, [
            _c("p", [
              _vm._v(
                "Kérjük adja meg a rendszerünkben való regisztrációhoz használt e-mail címét! "
              ),
            ]),
            _c(
              "form",
              {
                attrs: {
                  method: "post",
                  action: "api/ajax-request-new-password.php",
                  id: "newPasswordForm",
                },
              },
              [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.email,
                      expression: "email",
                    },
                  ],
                  class: { "form-control": true, "form-input-item": true },
                  attrs: { type: "text", placeholder: "E-mail cím" },
                  domProps: { value: _vm.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.email = $event.target.value
                    },
                  },
                }),
              ]
            ),
          ]),
          _c("div", { staticClass: "modal-footer" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-secondary ",
                attrs: { type: "button", "data-dismiss": "modal" },
              },
              [_vm._v("Bezár")]
            ),
            _c(
              "button",
              {
                staticClass: "btn button button-sm",
                attrs: { type: "button" },
                on: { click: _vm.getpassword },
              },
              [_vm._v("Rendben")]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "modal-header" }, [
      _c("h5", { staticClass: "modal-title" }, [_vm._v("Új jelszó igénylése")]),
      _c(
        "button",
        {
          staticClass: "close",
          attrs: {
            type: "button",
            "data-dismiss": "modal",
            "aria-label": "Close",
          },
        },
        [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }